import { useEffect, useState } from 'react';
import { aceptarMisMarcas, getMisPropuestas, rechazarMisMarcas } from '../services/marcasService';

const formato = (item) => {
  if (item.movimiento === 'ranking') {
    const categoria = item.categoria ? ` en ${item.categoria}` : '';
    return `Puesto ${item.valor}${categoria}`;
  }
  return `${item.movimiento_label}: ${item.valor} kg`;
};

// Si se pasa `claveSesion`, al cerrar con "Ahora no" no se vuelve a mostrar en esa pestaña
// hasta cerrar el navegador (se usa en el inicio para no insistir en cada visita).
const yaCerradoEnSesion = (clave) => {
  if (!clave) return false;
  try { return sessionStorage.getItem(clave) === '1'; } catch { return false; }
};

const MarcasPendientesPopup = ({ onAceptadas, claveSesion }) => {
  const [pendientes, setPendientes] = useState([]);
  const [abierto, setAbierto] = useState(false);
  const [ocupado, setOcupado] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelado = false;
    if (yaCerradoEnSesion(claveSesion)) return undefined;
    getMisPropuestas()
      .then((data) => {
        if (cancelado) return;
        const items = data.pendientes || [];
        setPendientes(items);
        setAbierto(items.length > 0);
      })
      .catch(() => {});
    return () => { cancelado = true; };
  }, [claveSesion]);

  if (!abierto || pendientes.length === 0) return null;

  const competiciones = [...new Set(pendientes.map((p) => p.meet_nombre).filter(Boolean))];

  const aceptar = async () => {
    setOcupado(true);
    setError('');
    try {
      const data = await aceptarMisMarcas();
      setAbierto(false);
      onAceptadas?.(data.marcas);
    } catch (e) {
      setError(e.message);
    } finally {
      setOcupado(false);
    }
  };

  const rechazar = async () => {
    setOcupado(true);
    setError('');
    try {
      await rechazarMisMarcas();
      setAbierto(false);
    } catch (e) {
      setError(e.message);
    } finally {
      setOcupado(false);
    }
  };

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="titulo-marcas"
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0, 0, 0, 0.45)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
        padding: 16,
      }}
    >
      <div style={{
        background: '#fff',
        borderRadius: 12,
        maxWidth: 440,
        width: '100%',
        padding: '1.5rem',
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.18)',
      }}>
        <h2 id="titulo-marcas" style={{ margin: '0 0 0.5rem', color: '#1a4d8c' }}>
          Tus marcas de la competencia
        </h2>
        <p style={{ margin: '0 0 1rem', color: '#444' }}>
          {competiciones.length
            ? `Resultados de ${competiciones.join(', ')}. `
            : ''}
          Confirma si estas son tus marcas.
        </p>
        <ul style={{ margin: '0 0 1rem', paddingLeft: '1.2rem', lineHeight: 1.6 }}>
          {pendientes.map((item) => (
            <li key={item.id}>{formato(item)}</li>
          ))}
        </ul>
        {error && <p style={{ color: '#c62828' }}>{error}</p>}
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <button
            type="button"
            onClick={aceptar}
            disabled={ocupado}
            style={{
              background: '#1a4d8c',
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              padding: '10px 16px',
              fontWeight: 700,
              cursor: 'pointer',
            }}
          >
            Aceptar
          </button>
          <button
            type="button"
            onClick={rechazar}
            disabled={ocupado}
            style={{
              background: '#fff',
              color: '#c62828',
              border: '1px solid #c62828',
              borderRadius: 8,
              padding: '10px 16px',
              fontWeight: 700,
              cursor: 'pointer',
            }}
          >
            Rechazar
          </button>
          <button
            type="button"
            onClick={() => {
              if (claveSesion) {
                try { sessionStorage.setItem(claveSesion, '1'); } catch { /* sin almacenamiento */ }
              }
              setAbierto(false);
            }}
            disabled={ocupado}
            style={{
              background: 'transparent',
              border: 'none',
              color: '#555',
              cursor: 'pointer',
              fontWeight: 600,
            }}
          >
            Ahora no
          </button>
        </div>
      </div>
    </div>
  );
};

export default MarcasPendientesPopup;
